import { createContext, useContext } from 'react'
import { type NavContextValue } from './nav.types'

export const NavContext = createContext<NavContextValue>(null)

export const useNavContext = () => useContext(NavContext)
